import { gql } from '@apollo/client';

// Fragments are spread using its assigned <NAME> not its variable name
// Example: fragment <NAME> on <Type>

// Import copy:
// import { _DETAILS } from '@/lib/graphql/fragments';

export const BULK_INVENTORY_EVENT_CREATE = gql`
  mutation bulkInventoryEventCreate(
    $inventoryEventAttributes: InventoryEventAttributes!
    $serialNumber: String!
    $gtin: String
    $lot: String
    $expiration: MDate
    $destructionReason: String
    $limit: Int
    $companyId: ID!
    $useFromZone: Boolean
  ) {
    bulkInventoryEventCreate(
      inventoryEventAttributes: $inventoryEventAttributes
      serialNumber: $serialNumber
      gtin: $gtin
      lot: $lot
      expiration: $expiration
      destructionReason: $destructionReason
      limit: $limit
      companyId: $companyId
      useFromZone: $useFromZone
    )
  }
`;

export const BULK_PRODUCT_STATUS_UPDATE = gql`
  mutation bulkProductStatusUpdate(
    $fromProductAttributes: ProductAttributes!
    $toProductAttributes: ProductAttributes!
    $serialNumber: String
    $limit: Int
    $unsetSalesOrder: Boolean
    $missingCount: Int
    $lot: String
    $destructionReason: String
  ) {
    bulkProductStatusUpdate(
      fromProductAttributes: $fromProductAttributes
      toProductAttributes: $toProductAttributes
      serialNumber: $serialNumber
      limit: $limit
      unsetSalesOrder: $unsetSalesOrder
      missingCount: $missingCount
      lot: $lot
      destructionReason: $destructionReason
    ) {
      success
      packaging
    }
  }
`;

export const USER_DETAILS = gql`
  fragment USER_DETAILS on User {
    id
    name
    firstName
    lastName
    username
    email
    phone
    roles
    status
  }
`;

export const PUBLISHER_DETAILS = gql`
  fragment PUBLISHER_DETAILS on Publisher {
    id
    name
    founded
    location
  }
`;

export const AUTHOR_DETAILS = gql`
  fragment AUTHOR_DETAILS on Author {
    id
    name
    country
    age
  }
`;

export const BOOK_DETAILS = gql`
  fragment BOOK_DETAILS on Book {
    id
    title
    publishedDate
    pages
    language
    authors {
      id
      name
    }
    publisher {
      id
      name
    }
  }
`;
